<template>
  <div class="loginBox">
    <div class="loginSuccess" v-if="codeStatus[ckStatus] == 1001">
      <p class="title">您的账号信息</p>
      <div class="userInfo">
        <img :src="userInfo.headerimg" alt="" />
        <p class="name">{{ userInfo.nickname }}</p>
      </div>
      <div class="opation">
        <p class="active" @click="submit">确认登录</p>
        <p @click="cancel">取消</p>
      </div>
    </div>
    <div class="loginError" v-if="codeStatus[ckStatus] == 1003">
      <div>
        <i></i>
        <p class="tip">登录失败，请重新扫描</p>
        <div class="opation">
          <p class="active">重新扫描</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ck: "",
      ckStatus: "",
      codeStatus: {
        G: 1000, //生成
        S: 1001, //app已扫
        C: 1002, //app确认
        D: 1003, //失效
      },
      userInfo: {},
    };
  },
  components: {},
  mounted() {
    var _this = this;
    //延时解决ios注入慢的问题
    setTimeout(function () {
      if (
        typeof window.IARTSCHOOL != "undefined" ||
        typeof window.android != "undefined"
      ) {
        _this.ck = _this.$route.query.ck ? _this.$route.query.ck : "";
        if (_this.ck) {
          _this.login();
        }
        if (localStorage.getItem("authorization")) {
          _this.getuserInfo();
        } else {
          _this.status = 0;
          _this.util.toast({ msg: "请先登录" });
        }
      } else {
        _this.down();
      }
    }, 50);
  },
  methods: {
    getuserInfo() {
      this.$post("/iart-api-crm/api/crm/customer/query", {}).then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            this.userInfo = res.data;
          } else {
            this.util.toast({
              msg: res.message,
            });
          }
        }
      });
    },
    login() {
      var obj = {
        ck: this.ck,
      };
      this.$post("/iart-api-crm/api/crm/qrcode/scanLogin", obj).then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            this.ckStatus = res.data.ckcode;
            if (res.data.rtncode == 1) {
            } else {
              this.util.toast({
                msg: res.data.rtnmsg,
              });
            }
          } else {
            this.util.toast({
              msg: res.message,
            });
          }
        }
      });
    },
    submit() {
      var obj = {
        ck: this.ck,
      };
      this.$post("/iart-api-crm/api/crm/qrcode/scanConfirm", obj).then(
        (res) => {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              if (res.data.ckcode == "C") {
                this.util.appFunction.back();
              }
            } else {
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    cancel() {
      this.util.appFunction.back();
    },
    down() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        window.location.href = this.$store.state.state.androidUrl;
      } else if (isiOS) {
        window.location.href = this.$store.state.state.iosUrl;
      }
      //   this.$router.push({
      //   path: '/common/downloadTransit'
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.loginBox {
  background: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  .loginSuccess {
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 50px 16px;
    .title {
      font-size: 18px;
      line-height: 25px;
      color: #333333;
      font-weight: bolder;
      text-align: center;
    }
    .userInfo {
      margin-top: 16px;
      img {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        object-fit: cover;
      }
      .name {
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        margin-top: 12px;
      }
    }
  }
  .loginError {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    > div {
      text-align: center;
      width: 100%;
      i {
        display: inline-block;
        width: 60px;
        height: 60px;
        background: url(../../../assets/img/app/login/error.png) no-repeat;
        background-size: 60px 60px;
      }
      .tip {
        font-size: 18px;
        line-height: 25px;
        color: #333333;
        font-weight: bolder;
        margin-top: 20px;
      }
    }
  }
  .opation {
    margin-top: 40px;
    p {
      font-size: 16px;
      line-height: 22px;
      color: #666666;
      border: 0.5px solid #cccccc;
      text-align: center;
      padding: 12px 0;
      border-radius: 4px;
      background: #fff;
    }
    p.active {
      color: #ffffff;
      background: #f62625;
      border-color: #f62625;
    }
    p:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}
</style>